export interface IActionRequiredModalProps {
  open: boolean;
  onClose: () => void;
  products?: string[];
  limusPerformProducts?: string[];
}

export enum ProductContext {
  photoID = 'photoID',
  limusPerform = 'limusPerform',
  multi = 'multi',
}
